import { LogHelper } from '@/helpers/Log'
import FileService from '@/services/File'
import MasterdataService from '@/services/Masterdata'
import OvpService from '@/services/Ovp'
import PartnerWidgetService from '@/services/PartnerWidget'

import ValidationService from '@/services/Validation'
import ResourcesService from '@/services/Resources'

import { ApplicationHelper } from '@/helpers/Application'
import {
  SOURCE_BACKEND
} from '@/config/events'
import { ErrorHelper } from '@/helpers/Error'
import UserRegistryService from '@/services/UserRegistry'

const isProduction = process.env.NODE_ENV === 'production'

const msInterceptor = {
  responseSuccess: response => {
    ApplicationHelper.emitMessages(response.data.infoMessages)
    return response.data
  },
  responseError: error => {
    // This error needs to be handled by the invoking service.
    let errorResponse = ErrorHelper.createErrorResponse(error)
    const { infoMessages, status } = errorResponse

    switch (status) {
      // 400 Bad Request: Something is wrong with the user input.
      case 400:
        LogHelper.error(error)
        break

      // 401 Unauthorized: SES session is no longer valid.
      case 401:
        // session-logged out need to error handling (refresh / routing to reentry!)
        return ApplicationHelper.restartApplication().then(() => Promise.reject(error))

      // 403 Forbidden: The user does not have the required rights to use this service.
      // case e.g. get secured basket without than -> don't display error, expected on reentry
      case 403:
        return Promise.reject(errorResponse)

      // 404 Not found. e.g. masterdata location search
      case 404:
        return Promise.reject(error)

      // 504 Gateway timeout error
      case 504:
      // 999 Custom code for axios timeout error (e.g. offline behavior)
      case 999:
        if (isProduction) {
          ApplicationHelper.emitMessages([{ errorCode: 'TIMEOUT', errorLevel: 'ERROR' }])
        }

      // If there is no explicit info message key we show a general error message
      default:
        if (isProduction && infoMessages.length === 0) {
          console.error(SOURCE_BACKEND, error)
        }
        errorResponse = error
        break
    }

    // We always need to reject the promise or this will run into the then callback (success).
    ApplicationHelper.emitMessages(infoMessages)
    return Promise.reject(errorResponse)
  }
}

const Backend = {
  initialize({ microserviceBaseUrl, resourceBaseUrl }) {
    this.file = new FileService(microserviceBaseUrl, msInterceptor)
    this.masterdata = new MasterdataService(microserviceBaseUrl, msInterceptor)
    this.ovp = new OvpService(microserviceBaseUrl, msInterceptor)
    this.partnerWidget = new PartnerWidgetService(microserviceBaseUrl, msInterceptor)
    this.resources = new ResourcesService(resourceBaseUrl, msInterceptor)
    this.userRegistry = new UserRegistryService(microserviceBaseUrl, msInterceptor)
    this.validation = new ValidationService(microserviceBaseUrl, msInterceptor)
  },

  install(Vue, options) {
    Vue.prototype.$backend = this
  }
}

export default Backend
